// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";
import { connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAZKM9whqGSLIpAWelsehFvz6ZkaudkLk",
  authDomain: "reclame-rio.firebaseapp.com",
  projectId: "reclame-rio",
  storageBucket: "reclame-rio",
  messagingSenderId: "753378914353",
  appId: "1:753378914353:web:c8683eb453c7557543a510",
  measurementId: "G-ZGZR77B3DQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Use emulators in local environments
// if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === "local") {
//   const auth = getAuth(app);
//   const firestore = getFirestore(app);
//   const storage = getStorage(app);
//   const functions = getFunctions(app);

//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(firestore, "localhost", 8080);
//   connectStorageEmulator(storage, "localhost", 9199);
//   connectFunctionsEmulator(functions, "localhost", 5001);

//   console.log("Emulators enabled: ", process.env.REACT_APP_ENV);
// } else {
//   console.log("Emulators disabled: ", process.env.REACT_APP_ENV);
// }

export const Firebase = app;
export const Analytics = analytics;
